import { StarOutlined } from "@ant-design/icons";
import React from "react";

interface AnimatedLogoProps {
  size?: "small" | "medium" | "large";
  showStar?: boolean;
  className?: string;
}

const AnimatedLogo: React.FC<AnimatedLogoProps> = ({
  size = "medium",
  showStar = true,
  className = "",
}) => {
  const getSizeClasses = () => {
    switch (size) {
      case "small":
        return "w-16 h-16 p-4";
      case "large":
        return "w-32 h-32 p-6";
      default:
        return "w-20 h-20 p-6";
    }
  };

  const getImageSize = () => {
    switch (size) {
      case "small":
        return "w-8 h-8";
      case "large":
        return "w-20 h-20";
      default:
        return "w-8 h-8";
    }
  };

  return (
    <div className={`relative inline-block ${className}`}>
      <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full blur-xl opacity-30 animate-pulse"></div>
      <div
        className={`relative bg-white dark:bg-gray-800 rounded-full shadow-2xl ${getSizeClasses()}`}
      >
        <img
          src="/logo.svg"
          alt="Logo"
          className={`${getImageSize()} object-contain transition-all duration-1000`}
        />
      </div>
      {showStar && (
        <div className="absolute -top-2 -right-2">
          <StarOutlined
            className="text-red-400 text-xl animate-spin"
            style={{ animationDuration: "3s" }}
          />
        </div>
      )}
    </div>
  );
};

export default AnimatedLogo;
